import axios from 'axios';

export const countryDomain = {
  Indonesia: ".co.id/",
  Vietnam: ".vn/",
  Thailand: ".co.th/",
  Philippines: ".ph/",
  Malaysia: ".com.my/",
  // Singapore: ".sg/",
  // other: ".com/"
}

export const linkMap = {
  production: 'https://shopeepay',
  // livetest: 'https://live-test.shopeepay',
  // uat: 'https://uat.shopeepay',
  test: 'https://test.shopeepay',
  local: 'https://test.shopeepay',
};

// get country of user's current location
export async function getGeoInfo() {
  const response = await axios.get('https://ipapi.co/json/');
  return response.data.country_name;
}